import { render, staticRenderFns } from "./AddStaffMemberDialog.vue?vue&type=template&id=e38909b6"
import script from "./AddStaffMemberDialog.vue?vue&type=script&lang=js"
export * from "./AddStaffMemberDialog.vue?vue&type=script&lang=js"
import style0 from "./AddStaffMemberDialog.vue?vue&type=style&index=0&id=e38909b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports